import { Component, OnInit,ViewChild,ElementRef,Renderer2, Input, OnDestroy} from '@angular/core';
import {getSafeRanges} from './content';
import { UserService } from 'src/app/shared/services/user.service';
import * as Editor from '../../../assets/ckeditor/build/ckeditor';
import { FlashcardService } from 'src/app/shared/services/flashcard.service';
import { QuizServiceService } from 'src/app/shared/services/quiz-service.service';
import { MessageService } from 'primeng/api';

class Topic {
  title: string;
  status: boolean;
  subTopics :Topic[] = []
  description:string;
  articleId:any;
  bookmark:boolean;
  constructor( topic :string , subTopics=[], articleId = null) {
    this.articleId = articleId;
    this.title = topic;
    this.status = false;
    this.subTopics = subTopics
    this.bookmark =false;
  }
}

@Component({
  selector: 'app-medicallibrary',
  templateUrl: './medicallibrary.component.html',
  styleUrls: ['./medicallibrary.component.scss', './flashbardstyling.scss', '../../../assets/stylesheet/toggle-btn.css'],
  providers: [MessageService]
})
export class MedicallibraryComponent implements OnInit, OnDestroy {


  @ViewChild('articleContent', { static: false }) articleContainer!: ElementRef;

  bookmarked= []
  width = 200; // Initial width
  translateX = 0; // Initial position
  isResizing = false;
  searchWord =null
  filteredArticles = []
  editBookmark=false
  selectedFlashcard: any;
  selectedBookmarks =[]
  selectedArticle :any= null;
  isHighlighting = false;
  displayCardOptions = false
  displayEditFlashcard = false
  showFlashcard = false;
  loader=false;
  libraryLoader = false;
  flags = {
    showContent :false,
    showSearch :false,
    bookmarks:false,
  }
  displayImg = false
  card = {
    "question": "",
    "answer": "",
    "tags": [],
    "deckId": -1,
    "questionId": -1
  }
  annotation =[]
  showImage = ''
  displayDropdown = false;
  showType = 0;

  displayFlashcards = false
flashcards = []
  // FullScreen
  isFullScreen = false;

  highlights: string[] = [];
  highlightEnabled = true;
  isIpad = true;
  annotationPopuop = false;
  tourOptions = {
    subjects: ['Welcome'],
    status:false,
    bookmark:false,
    articleId:1,
    title: 'Welcome to the Medical Library',
    content: `<div><span class="article-body-headers article-body-header" data-node-name="h1" bookmark-id="A586SH01">Overview of the Medical Library</span> <p>The Medical Library is a comprehensive knowledge platform for students, residents, and practicing physicians.&nbsp; It contains <strong>600+</strong> unique, up-to-date, peer-reviewed articles that integrate with your QBank to deliver an ideal review experience for exam prep and daily practice.</p> <ul class="article-body-unordered-list"> <li><strong>For medical students focusing on their preclinical curriculum:</strong>&nbsp; Connect pathophysiology with testable clinical manifestations for a more rounded view of topics you're studying.</li> <li><strong>For medical students on their clinical rotations:</strong>&nbsp; Strengthen your clinical reasoning skills, refine your understanding of differential diagnoses, and find answers to clinical and management questions.</li> <li><strong>For residents and practicing physicians:</strong>&nbsp; Validate your findings and refresh your knowledge on specific topics.</li> </ul> <span class="article-body-headers article-body-header" data-node-name="h1" bookmark-id="A586SH02">How to Find Articles (Search)</span> <p>The Medical Library makes it easy to find additional context on topics you're studying or to validate your clinical findings during practice.&nbsp; To get started, select "<strong>Search Medical Library</strong>" at the top-left corner of your screen and enter your query.</p> <p>We suggest searching for specific topics or keyword phrases just as you would in My Notebook.&nbsp; The search bar looks for your query in the title and body text of our 600+ curated articles.&nbsp; If the library has content supporting your inquiry, it will be highlighted in your results, which will be sorted by relevance.&nbsp; Article titles will appear bolded, followed by a short snippet of the article highlighting your query.</p> <p>If you select an article and would like to return to your search results, click "<strong>Back to Previous Page</strong>" at the top-left corner of your screen.&nbsp; You can then explore other query-related articles or enter a new search.</p><br> <span class="article-body-headers article-body-header" data-node-name="h1" bookmark-id="A586SH03">How to Use Bookmarks (Save)</span> <p>Bookmarks are useful when you are studying a difficult topic, have a patient with needs that you are less familiar with, or want to save specific articles for future use.&nbsp; To make a new bookmark, select the <strong>star icon</strong> in the article tools bar.</p> <p>You can view your saved resources by clicking "<strong>Bookmarks</strong>" in the navigation menu on the left side of your screen.&nbsp; This tab also opens a search bar where you can look up specific bookmarks as needed.</p> <p>At the top-right corner of your Bookmarks screen, you'll find an <strong>edit icon</strong> that opens a multi-select option to remove bookmarks individually or in bulk.</p><br> <span class="article-body-headers article-body-header" data-node-name="h1" bookmark-id="A586SH04">How to Use Article Tools (Customize)</span> <p>The Medical Library integrates your QBank tools to help you add clinical context to your flashcards and notes, and to further optimize your review sessions.&nbsp; You can access them by highlighting content or using the article tools bar at the bottom of your screen.</p> <p>When you select content, a <strong>pop-up menu</strong> that has similar functionality to the menu in your answer explanations will appear.&nbsp; You can highlight text, create a new flashcard, edit an existing flashcard, or transfer the content into My Notebook.</p><br> <span class="article-body-headers article-body-header" data-node-name="h1" bookmark-id="A586SH05">Your Essential Online Medical Library</span> <p>The Medical Library transforms your QBank into an all-in-one resource for clinical content mastery by expanding on the topics you need to know.&nbsp; Get fast, reliable answers to your clinical questions while studying, preparing for exams, or managing patients.</p> </div>`,
    options:[]
  }

  demoOptions = {
    subjects: ['Free Trial'],
    status:false,
    bookmark:false,
    articleId:1,
    title: 'Welcome to Free Trial',
    content: `<div><span class="article-body-headers article-body-header" data-node-name="h1" bookmark-id="A586SH01">Free trial is for testing, saving text is available only for premium users </span></div>`,
    options:[]
  }

  searcher = false
  displayDeck = false;
deck = {
  "userId": localStorage.getItem('Id'),
  "title": "",
  "color": "#62B5FC"
}

flashcardKeyword = ''

flashcardView = 'Single Side View'
position = 'Front'


deckColors = ['#62B5FC', '#F15856', '#FB7915', '#FFCC33', '#B13EDB',
'#7274E1', '#6E756D', '#BF5D5D', '#FF8BF0', '#36C8A3'] 


  highlightingFailed = false;
  selectedData :any= {}
  counter = 0
  safeRanges: any;
  safeRangeSingle:any;
  selectedTranslation = {
    question: false,
    explanation: false
  };
  isDemo = false;
  tempFlashcards: any = []

  ckEditorFront: any;
  ckEditorBack: any;
  
  frontEditor: any;
  backEditor: any;
  allQuestions: any;
  currentQuestionIndex: any;
  selectedDeck: any;
decks = []
createFlashcard = false;
questionFlashcards = []
showFlashcards = []
editAnnotation = false;
editableAnnotation :any;
  selectedAnnotation=null
    highlightOnlyMode = false;
    multiHighlightMode = false;
    isChecked: { [key: number]: boolean } = {};
  libraryObject : Topic[]=[]
  displayContinue = false
displayCards = false
existingFlashcard = false
tempArticle :any;
html = ""
  highlightedText: string = '';

  //notebook dialig variables 
  shownotebookdialog = false;

  prevPages: any = [];

  courses: any = []
  selectedCourse = null;

  @Input() isQuizModule = false;
  @Input() searchedWord = '';
  currentFontSize: any;

  highlightSelected = 'highlighter-1';

  aiFlashcards = null;
  displayAIFlashcards = false;
  flashcardSelection = 0;
  selectedAIDeck = null;
  aiDecks = [];

  aiLoader = false;
  aiText = '';

  searchCount = 0;
  searchEnabled = false;
  isSearchTopic = false;
  matchIds = [];
  searchedIndex = 0;

  displayFeedback = false;
  feedbackText = '';
  buttonLoader = false;

  searchTerm: string = '';
  debounceTimer: any;

  // Mobile responsiveness properties
  showMobileSidebar = false;
  isMobile = false;

  constructor(private renderer: Renderer2, private flashcardService: FlashcardService, private userService:UserService, private quizService: QuizServiceService, private messageService: MessageService) { }

  async ngOnInit(): Promise<void> {
    // Check if device is mobile
    this.checkMobileDevice();
    
    // Listen for window resize events
    window.addEventListener('resize', () => {
      this.checkMobileDevice();
    });
    
    if (localStorage.getItem('Id') == '-1') {
      this.isDemo = true;
      this.demoOptions.status = true;
      this.selectedArticle = JSON.parse(JSON.stringify(this.demoOptions));
      this.tempArticle =  JSON.parse(JSON.stringify(this.selectedArticle))
      this.updateFlags('showContent');
    } else {
      this.courses = JSON.parse(localStorage.getItem('subscriptions'))
      if (this.courses.length > 0) {
        this.selectedCourse = this.courses[0].courseID
  
        if (sessionStorage.getItem('userSelectedCourse')) {
          const courseId = this.courses.find((item: any) => item.courseName == sessionStorage.getItem('userSelectedCourse')).courseID
          this.selectedCourse = courseId;
        }
  
        if (sessionStorage.getItem('medicalLibrary')) {
          const course = sessionStorage.getItem('medicalLibrary');
          this.selectedCourse = parseInt(course);
        }

        let course = null;
        if (this.selectedCourse == 135631) {
          course = 115015;
        } else {
          course = this.selectedCourse;
        }
    
        sessionStorage.setItem('medicalLibrary', this.selectedCourse);
        await this.getMedicalLibrary(course)
  
        if (sessionStorage.getItem('libraryFontSize')) {
          this.currentFontSize = JSON.parse(sessionStorage.getItem('libraryFontSize'));
          setTimeout(() => {
            document.getElementById('articleContent').style.fontSize = `${this.currentFontSize}px`
          }, 25)
        } else { 
          this.currentFontSize = 16;
        }
  
        if(sessionStorage.getItem('libraryHighlightOnly')) {
          this.highlightOnlyMode = JSON.parse(sessionStorage.getItem('libraryHighlightOnly'));
        }

        if(sessionStorage.getItem('libraryMultiHighlight')) {
          this.multiHighlightMode = JSON.parse(sessionStorage.getItem('libraryMultiHighlight'));
        }
      }
    }
  }

  ngOnDestroy(): void {
    const arr = ['medicalLibrary', 'libraryFontSize', 'libraryHighlightOnly', 'libraryMultiHighlight'];
    arr.forEach(item => {
      sessionStorage.removeItem(item);
    });
  }

  async changeArticles() {
    this.resetSearch();
    this.prevPages = [];


    let course = null;
    if (this.selectedCourse == 135631) {
      course = 115015;
    } else {
      course = this.selectedCourse;
    }

    sessionStorage.setItem('medicalLibrary', this.selectedCourse);
    await this.getMedicalLibrary(course);
  }
 
  activeOption(option: any)
  {
    this.tourOptions.options.forEach((element:any) => {
      element.status = false;
    });
    option.status = true;
    
  }
  activeMainCategory(category: any)
  {
    this.libraryObject.forEach((element:any) => {
      if (element.article_id !== category.article_id) {
        element.status = false;
      }
    });
    category.status = !category.status;
  }
  activeSubcategory(subCat: any, subTopics: any, title: any, navigateBack: boolean)
  {
    this.HideHighlightControls();
    this.updateFlags('showContent');
    this.tourOptions.status = false;
    this.libraryObject.forEach((library: any) => {
      library.subTopics?.map((item: any) => item.status = false);
    });
    
    subTopics.forEach((element:any) => {
      element.status = false;
    });
    subCat.status = true;
    subCat.subTopics?.sort((a: any, b: any) => a.orderBy - b.orderBy);
    // get the content for this subcategory 
    subTopics.map(async (article: any)=> {
      if (subCat.articleId == article.articleId) {
        if (!article.content) {
          article.content = await this.getArticleContent(article.articleId)
        }
        this.viewUserArticle(article.articleId);
        //@ts-ignore
        this.selectedArticle = JSON.parse(JSON.stringify(article));
        this.selectedArticle.content = this.addIDsToFigure(this.selectedArticle.content);
        this.selectedArticle.content = this.replaceTableWithLink(this.selectedArticle.content);
        try {
          this.selectedArticle.relatedArticles = JSON.parse(this.selectedArticle.relatedArticles);
        } catch (e) {}
        this.tempArticle = JSON.parse(JSON.stringify(this.selectedArticle));
        if (!navigateBack) {
          this.prevPages.push(article);
        }
        this.getUserAnnotations(); 
      }
    })

    setTimeout(() => {
      this.scrollToHeading('article-content');
    }, 25)
  }
  
  bookmarkCategory(subcategory)
  {
    subcategory.bookmark = !subcategory.bookmark;
  }
  activeTopic(topic , topicsList)
  {
    topicsList.forEach((element:any) => {
      element.status = false;
    });
    topic.status = true;
  }

  openSearchTopic() {
    this.matchIds = [];
    this.searchCount = 0;
    this.searchedIndex = 0;
    this.searchEnabled = false;
    this.isSearchTopic = !this.isSearchTopic;
    this.selectedArticle.content = JSON.parse(JSON.stringify(this.tempArticle.content));
  }

  searchTopic(event: any) {
    this.searchCount = 0;
    this.searchedIndex = 0;
    this.searchEnabled = false;
    this.selectedArticle.content = JSON.parse(JSON.stringify(this.tempArticle.content));
  
    if (event.target.value.length > 0) {
      this.searchedIndex = 1;
      this.searchEnabled = true;
      const searchTerm = event.target.value;
  
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.tempArticle.content, "text/html");
      const body = doc.body;
  
      let matchIndex = 0;
      this.matchIds = [];
  
      const highlightText = (node: Node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          // Skip if the parent is already a highlighted span
          if (node.parentElement?.classList.contains("search-highlight")) {
            return;
          }
  
          // Match with case sensitivity preserved
          const regex = new RegExp(`(${searchTerm})`, "gi");
          const matches = node.nodeValue!.match(regex);
  
          if (matches) {
            this.searchCount += matches.length;
  
            const newNode = document.createElement("span");
            newNode.innerHTML = node.nodeValue!.replace(regex, (match) => {
              const matchId = `match-${matchIndex++}`;
              this.matchIds.push(matchId);
              if (matchIndex === 1) {
                return `<span class="selected-highlight" id="${matchId}">${match}</span>`; // Use original case `match`
              } else {
                return `<span class="search-highlight" id="${matchId}">${match}</span>`; // Use original case `match`
              }
            });
  
            //@ts-ignore
            node.replaceWith(...Array.from(newNode.childNodes));
          }
        } else {
          // Recursively process child nodes
          node.childNodes.forEach(highlightText);
        }
      };
  
      highlightText(body);
  
      this.selectedArticle.content = body.innerHTML;

      setTimeout(() => {
        this.scrollToMatch(this.searchedIndex);
      }, 10)
    }
  }    

  scrollToMatch(index: number) {
    this.matchIds.forEach((item: any) => {
      const element = document.getElementById(item);
      if (element) {
        element.classList.remove('selected-highlight');
        element.classList.add('search-highlight');
      }
    })
    if (this.matchIds.length > (index - 1)) {
      const element = document.getElementById(this.matchIds[(index - 1)]);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.classList.remove('search-highlight');
        element.classList.add('selected-highlight')
      }
    }
  }

  nextSearchIndex() {
    if (this.searchedIndex < this.searchCount) {
      this.searchedIndex ++;
      this.scrollToMatch(this.searchedIndex);
    }
  }

  prevSearchIndex() {
    if (this.searchedIndex > 1) {
      this.searchedIndex --;
      this.scrollToMatch(this.searchedIndex);
    }
  }

  async searchArticles(value: any) {
    if (this.searchWord.length > 0 && value) {
      const term = this.searchWord;
      await this.searchArticleContent(term);
    } else {
      this.filteredArticles = [];
    }
  }

  runArticleSearch(term: string) {
    this.filteredArticles = [];
    const titleArticles = [];
    const contentArticles = [];
  
    if (!term || term.trim().length < 1) return;
  
    const lowerTerm = term.toLowerCase();
  
    this.libraryObject.forEach((element: any) => {
      if (element.subTopics?.length > 0) {
        element.subTopics.forEach((topic: any) => {
          const plainTitle = topic.title.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
          const lowerTitle = plainTitle.toLowerCase();
  
          let index = lowerTitle.indexOf(lowerTerm);
          if (index !== -1) {
            const found = JSON.parse(JSON.stringify(topic));
            titleArticles.push(found);
          } else {
            const plainText = topic.content.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
            const lowerText = plainText.toLowerCase();
    
            index = lowerText.indexOf(lowerTerm);
            if (index !== -1) {
              const found = JSON.parse(JSON.stringify(topic));
              found['searchedParagraph'] = this.getHighlightedChunk(plainText, term, index);
              contentArticles.push(found);
            }
          }
        });
      }
    });

    this.filteredArticles = [...this.filteredArticles, ...titleArticles, ...contentArticles];
  }
  
  getHighlightedChunk(text: string, word: string, index: number): string {
    const before = Math.max(0, index - 100);
    const after = Math.min(text.length, index + word.length + 100);
  
    let chunk = text.substring(before, after);
    chunk = '...' + chunk + '...';
  
    return chunk.replace(
      new RegExp(`(${word})`, 'gi'),
      `<span class="highlighter-1">$1</span>`
    );
  }

scrollToHeading(id: string) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

handleLinkClick(event: Event) {
  const target = event.target as HTMLElement;

  if (target.tagName === 'A' && target.hasAttribute('data-id')) {
    const id = target.getAttribute('data-id');
    this.displayImg = true;
    this.showImage = null;
    
    setTimeout(() => {
      this.showImage = id; 
      this.showType = 0;
      if (id.includes('<table>')) {
        this.showType = 1;
      }
      if (id.includes('.mp4')) {
        this.showType = 2;
      }
      if (id.includes('.mp3')) {
        this.showType = 3;
      }
    }, 2000)
  }
}

getBookmarkArticles() {
  return new Promise((resolve: any) => {
    this.bookmarked=[]
    this.libraryLoader = true;
    var data = {
      userID: localStorage.getItem('Id')
    }
  
    this.userService.getBookmarkArticles(data).subscribe({
      next:(res:any)=>{
        // process here and add the bookmarked articles in the list
        const articleList : any= this.libraryObject.map((element) => element.subTopics)
  
      
  
  
        res.bookmarkArticles.map((article: any)=>{
            articleList.map((content) => {
              if (content)
                {
                  content.map((art) => {
                  if (article.article_id == art.articleId) {
                    art['added_on']  = new Date( article.added_on )
                    art.bookmark =true;
                    this.bookmarked.push(art)
                   
                  }
                  })
                }
            })
          
         
        })
        this.libraryLoader = false;
        resolve(true);
      },
      error:(e)=>{
        console.log(e)
        this.libraryLoader = false;
        resolve(true);
      }  
    })
  })
}

addBookmarkArticles(article)
{

  this.libraryLoader = true;


//already bookmarked
// remove the bookmark 
var data;
  if (article.bookmark)
  {

    // get the bookmark id from bookmark array 
    
     data ={
      userID : localStorage.getItem('Id'),
      articleIDs :[article.articleId]
    }

  
    this.userService.removeBookmarkArticle(data).subscribe({
      next:(res:any)=>{
    
        this.getBookmarkArticles()
        this.libraryLoader = false;
      },
      error:(e)=>{
        this.libraryLoader = false;
      }  })
  }
  else{

     data = {
      userID : localStorage.getItem('Id'),
      articleID :article.articleId
    }
  
    
    this.userService.addBookmarkArticle(data).subscribe({
      next:(res:any)=>{
    
        this.getBookmarkArticles()
        this.libraryLoader = false;
      },
      error:(e)=>{
        this.libraryLoader = false;
      }  })
  }


}
onCheckboxChange(item: any , event)  {
  
  if (event.checked)
  {
    //check if already exists 
    const index = this.selectedBookmarks.findIndex((element) => element.articleId == item.articleId)
    if (index ==-1)
    {
      this.selectedBookmarks.push(item.articleId)
    }
  }
  //unchecked so remove now 
  else{
    this.selectedBookmarks = this.selectedBookmarks.filter(i => i !== item.articleId);
  }
 
}

cancelEdit()
{
  this.selectedBookmarks =[]
  this.editBookmark =false;
}
removeBookmarkArticles()
{

  //get the ids of all the selected articles

  var data ={
    userID : localStorage.getItem('Id'),
    articleIDs : this.selectedBookmarks
  }


  this.userService.removeBookmarkArticle(data).subscribe({
    next:(res:any)=>{
     
      this.getBookmarkArticles()
    },
    error:(e)=>{
     
    }  })
}

getMedicalLibrary(course: any) {
  return new Promise((resolve,reject)=>{
    this.libraryLoader = true;
    const data = {
      userId: localStorage.getItem('Id'),
      courseId: course
    }
    this.userService.getmedicalLibrary(data).subscribe({
      next: async (res:any) => {
        try {
          this.libraryObject = JSON.parse(res.medicalLibrary)
        } catch (e) {
          this.libraryObject = res.medicalLibrary
        }
        this.libraryObject.sort((a: any, b: any) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });        
        for (let i = 0; i < this.libraryObject.length; i++) {
          this.libraryObject[i].subTopics.sort((a: any, b: any) => {
            return a.title.localeCompare(b.title);
          });        
        }

        await this.getBookmarkArticles()

        if (this.searchedWord.length > 0) {
          this.libraryLoader = true;
          this.searchWord = this.searchedWord;
          this.updateFlags('showSearch');
          this.searchArticles(true);
        } else {
          let viewed = false;
          if (res.viewedArticle.length > 0) {
            for (let i = 0; i < this.libraryObject.length; i++) {
              const article = this.libraryObject[i].subTopics.find((item: any) => item.articleId === res.viewedArticle[0].article_id)
              if (article) {
                viewed = true;
                this.navigateToSearchedArticle(article)
                break;
              }
            }
          }
          if (!viewed) {
            this.tourOptions.status = true;
            this.selectedArticle = JSON.parse(JSON.stringify(this.tourOptions));
            this.tempArticle =  JSON.parse(JSON.stringify(this.selectedArticle))
          }
          this.updateFlags('showContent');
        }
        resolve(true)
      },
      error:(e)=>{
        
      }
    })
  })
}

highlightSelection() {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0 || selection.toString().trim() === '') return;

  const range = selection.getRangeAt(0);
  const startOffset = range.startOffset;
  const endOffset = range.endOffset;
  
  const span = this.renderer.createElement('span');
  this.renderer.setProperty(span, 'innerHTML', range.toString());
  this.renderer.setAttribute(span, 'class', 'highlight');

  range.deleteContents();
  range.insertNode(span);

  //@ts-ignore
  this.highlights.push({ text: selection.toString(), startOffset, endOffset });

  localStorage.setItem('highlights', JSON.stringify(this.highlights)); // Simulate saving
}


highlightTxt(): void{
  var control = document.getElementById('control-library');

  if (!this.highlightOnlyMode) {
    document.getElementById('highlightingIcon1-library-module').addEventListener('pointerdown', this.highlightingTextStart, true);

    if (this.multiHighlightMode) {
      document.getElementById('highlightingIcon2-library-module').addEventListener('pointerdown', this.highlightingTextStart, true);
      document.getElementById('highlightingIcon3-library-module').addEventListener('pointerdown', this.highlightingTextStart, true);
      document.getElementById('highlightingIcon4-library-module').addEventListener('pointerdown', this.highlightingTextStart, true);
      document.getElementById('highlightingIcon5-library-module').addEventListener('pointerdown', this.highlightingTextStart, true);
    }
    document.getElementById('annotations-library').addEventListener('pointerdown', this.showAnnotationBox, true);
    document.getElementById('notebook-library').addEventListener('pointerdown', this.addtoNotebook, true);
    document.getElementById('newFlashcard-library').addEventListener('pointerdown', this.addNewFlashcard, true);
    document.getElementById('existingFlashcard-library').addEventListener('pointerdown', this.addExistingFlashcard, true);
    document.getElementById('aiFlashcards-library').addEventListener('pointerdown', this.generateAIFlashcards, true);
  }

  var selection = window?.getSelection();

  var text = window?.getSelection()?.toString();
  // @ts-ignore
  if (selection) {
    var userSelection = window.getSelection()?.getRangeAt(0);
  }

  this.safeRanges = getSafeRanges(userSelection);
  this.safeRangeSingle = this.safeRanges[0];

  if (!this.highlightOnlyMode) {
    if(text.length>0 && !this.tourOptions.status) {
      let rect = selection.getRangeAt(0).getBoundingClientRect();
      control.style.top = `calc(${rect.top}px - 120px)`;
      control.style.left = `calc(${rect.left}px + calc(${rect.width}px / 2) - 40px)`;
      control['text']= text;
      document.getElementById('control-library').style.display = 'inline';
    } else {
      this.HideHighlightControls();
    }
  }

  if (this.highlightOnlyMode && !this.tourOptions.status) {
    if (selection.toString() !== '') {
      this.highlightSelected = 'highlighter-1';
      this.highlightRange('highlight');
    }
  }
}

HideHighlightControls(){
  var element  = document.getElementById('control-library')
  if (element) {
    document.getElementById('control-library').style.display = 'none';
  }

  
}

getStartandEnding(selection)
{
  
  
if (selection && selection.rangeCount > 0) {
  const range = selection.getRangeAt(0);
  const selectedText = selection.toString();

  const parentElement = range.commonAncestorContainer;
  let fullText = parentElement.textContent || ''; // Full text within the parent

  // Find all occurrences of the selected text
  let indices: number[] = [];
  let index = fullText.indexOf(selectedText);
  
  while (index !== -1) {
    indices.push(index);
    index = fullText.indexOf(selectedText, index + 1); // Find next occurrence
  }

  // Find the closest match based on range.startOffset
  let startIndex = -1;
  let endIndex = -1;
  for (let i = 0; i < indices.length; i++) {
    if (indices[i] >= range.startOffset) {
      startIndex = indices[i];
      endIndex = startIndex + selectedText.length;
      break;
    }
  }

  
}
}

showAnnotationBox = (event) => {
  this.editableAnnotation=null;
  this.editAnnotation=false;
  this.selectedAnnotation =null;
  this.annotationPopuop =true;
  
  let selection = document.getSelection();
  this.highlightRange('annotate');
  document.getElementById('control-library').style.display = 'none';
  event.stopPropagation();
}
highlightingTextStart =(event) => {
  this.highlightSelected = event.srcElement.id === 'highlightingIcon5-library-module' ? "highlighter-5" : event.srcElement.id === 'highlightingIcon4-library-module' ? "highlighter-4" : event.srcElement.id === 'highlightingIcon3-library-module' ? "highlighter-3" : event.srcElement.id === 'highlightingIcon2-library-module' ? "highlighter-2" : 'highlighter-1';
 this.highlightRange('highlight');
  document.getElementById('control-library').style.display = 'none';

  //text is fetched here 
  // now add the tag around the text and highlight it 

  // find the text from the article and 
  event.stopPropagation();
  this.HideHighlightControls();
}




getindexwrtOccurance(): void {
 
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    console.log("No text selected.");
    return;
  }

  // Get selected text
  const selectedText = selection.toString().trim();
  if (!selectedText) {
    console.log("No valid text selected.");
    return;
  }

  // Get actual article HTML content (with tags)
  const articleElement = document.getElementById("articleContent"); // Update with actual ID
  if (!articleElement) {
    console.log("Article content element not found.");
    return;
  }
  
  const contentHTML = articleElement.innerHTML; // HTML content
  const contentText = articleElement.textContent || ""; // Plain text content
  
  // Find all occurrences of the selected text
  let occurrence = 0;
  let lastIndex = 0;
  let selectedOccurrence = -1;

  while ((lastIndex = contentText.indexOf(selectedText, lastIndex)) !== -1) {
    occurrence++;

    // Get the selection's position in the DOM
    const range = selection.getRangeAt(0);
    const preSelectionRange = range.cloneRange();
    preSelectionRange.selectNodeContents(articleElement);
    preSelectionRange.setEnd(range.startContainer, range.startOffset);

    var selectionStartIndex = preSelectionRange.toString().length;

    // Check if this occurrence is the one user selected
    if (lastIndex === selectionStartIndex) {
      selectedOccurrence = occurrence;
      break;
    }

    lastIndex += selectedText.length; // Move to the next occurrence
  }

  
}


highlightRange(type: any): void {
  //  this.getindexwrtOccurance()

  var selection = document.getSelection();
  if (!selection.rangeCount) return;
  let html :any;
   selection = document.getSelection();
  if (typeof window.getSelection != "undefined") {
    var sel = window.getSelection();
    if (sel.rangeCount) {
        var container = document.createElement("div");
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
            container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
    }
     }

 
    //  remove the strt and ending tags if they exists
  
    html = html.replace(/^(\s*<[^>]+>\s*)+|(\s*<[^>]+>\s*)+$/g, '');

     var selection = window?.getSelection();

if (!selection || selection.rangeCount === 0) {
  console.log("No text selected.");
} else {
  var range = selection.getRangeAt(0).cloneRange();
  var startContainer = range.startContainer;
  var startOffset = range.startOffset;
  var endContainer = range.endContainer;
  var ranges: Range[] = [];

  const excludedClasses = [
    "csq-submit-btn-wrapper", "csq-question-options", "csq-footer-wrapper", 
    "csq-relative-position", "AI_features", "answer-stats-area", 
    "explanation-nav-tab", "explanation-course"
  ];

  // Function to check if a node is inside an excluded element
  function isInsideExcludedElement(node: Node): boolean {
    while (node) {
      if (node.nodeType === 1) {
        const element = node as HTMLElement;
        if (excludedClasses.some(cls => element.classList.contains(cls))) {
          return true;
        }
      }
      node = node.parentNode!;
    }
    return false;
  }

 

  this.selectedData['text'] = html;

  if (type=='highlight' && html !== '' && html !== ' ' && html.trim() !== '&nbsp;')
  {
    this.savehighlight(html)
    while (startContainer !== endContainer) {
      if (isInsideExcludedElement(startContainer)) {
        break;
      }
  
      let startText = startContainer.nodeValue;
      let currentRange = range.cloneRange();
      currentRange.setEnd(startContainer, startText ? startText.length : 0);
      ranges.push(currentRange);
  
      let sibling = startContainer;
      do {
        if (sibling.hasChildNodes()) {
          sibling = sibling.firstChild!;
        } else if (sibling.nextSibling) {
          sibling = sibling.nextSibling!;
        } else {
          while (!sibling.nextSibling && sibling.parentNode) {
            sibling = sibling.parentNode;
          }
          if (sibling) {
            sibling = sibling.nextSibling!;
          }
        }
      } while (sibling !== null && (sibling.nodeValue === null || isInsideExcludedElement(sibling)));
  
      if (!sibling) {
        break;
      }
      range.setStart(sibling, 0);
      startContainer = range.startContainer;
    }
  
    for (var i = 0; i < ranges.length; i++) {
      const label = document.createElement("label");
      label.className = this.highlightSelected
      label.setAttribute("id", "highlighter" + this.counter);
      var currentRange1 = ranges[i];
  
      try {
        currentRange1.surroundContents(label);
      } catch (e) {
        this.highlightingFailed = true;
      }
    }
  
    const label = document.createElement("label");
    label.className = this.highlightSelected
    label.setAttribute("id", "highlighter" + this.counter);
  
    try {
      range.surroundContents(label);
    } catch (e) {
      this.highlightingFailed = true;
    }
  
    this.counter++;
    localStorage.setItem("counter", JSON.stringify(this.counter));
  

  }


 



  selection.removeAllRanges();
}





}

findOccurrenceIndex(mainString, substring, startIndex) {
  let index = mainString.indexOf(substring);
  let occurrence = 0;

  while (index !== -1) {
      occurrence++;

      // If this is the occurrence that starts at startIndex, return its position
      if (index === startIndex) {
          return occurrence;
      }

      // Search for the next occurrence
      index = mainString.indexOf(substring, index + 1);
  }

  return -1; // Return -1 if no occurrence matches the given startIndex
}


// Function to get XPath of an element
getXPath(element: Node): string {
   if (element.nodeType === Node.TEXT_NODE) {
       element = element.parentElement!;
   }
   if (element instanceof Element && element.id) {
       return `//*[@id="${element.id}"]`;
   }

   const paths: string[] = [];
   while (element && element.nodeType === Node.ELEMENT_NODE) {
       let index = 1;
       let sibling = element.previousSibling;
       while (sibling) {
           index++;
           sibling = sibling.previousSibling;
       }
       const tagName = (element as Element).nodeName.toLowerCase();
       paths.unshift(`${tagName}[${index}]`);
       element = element.parentElement!;
   }
   return `/${paths.join("/")}`;
}

// Restore highlights on page load
restoreHighlights(): void {
   const highlights = JSON.parse(localStorage.getItem("highlights") || "[]");

   highlights.forEach(({ text, xpath }) => {
       const element = this.getElementByXPath(xpath);
       if (element) {
           const innerHTML = element.innerHTML;
           const regex = new RegExp(`(${text})`, "gi");
           element.innerHTML = innerHTML.replace(
               regex,
               `<span class="highlight" style="background-color:yellow;">$1</span>`
           );
       }
   });
}

// Function to get element by XPath
getElementByXPath(xpath: string): HTMLElement | null {
   return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null)
       .singleNodeValue as HTMLElement;
}

getSelectedOccurrenceIndex() {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return null; // No selection made
  }

  const selectedText = selection.toString().trim();
  if (!selectedText) return null;

  // Get only text content from a specific container (update this selector)
  const container = document.querySelector("#articleContent");
  //@ts-ignore
  const htmlString = container.innerText; 

  const occurrences: number[] = [];
  let index = htmlString.indexOf(selectedText);

  // Find all occurrences
  while (index !== -1) {
    occurrences.push(index);
    index = htmlString.indexOf(selectedText, index + 1);
  }

  // Find actual selected occurrence
  const range = selection.getRangeAt(0);
  const preSelectionRange = range.cloneRange();
  preSelectionRange.selectNodeContents(container);
  preSelectionRange.setEnd(range.startContainer, range.startOffset);
  const selectedStartIndex = preSelectionRange.toString().length;

  // Find which occurrence the selected index belongs to
  let occurrenceIndex = 0;
  for (let i = 0; i < occurrences.length; i++) {
    if (selectedStartIndex >= occurrences[i] && (i === occurrences.length - 1 || selectedStartIndex < occurrences[i + 1])) {
      occurrenceIndex = i + 1;
      break;
    }
  }

  return {
    selectedText,
    selectedStartIndex,
    occurrences,
    occurrenceIndex
  };
}


cancelAnnotation()
{
  this.annotationPopuop =false;
  this.selectedAnnotation =null;
}





saveAnnotation()
{
  var data ={
    
      "articleID":this.selectedArticle.articleId,
      "userID": localStorage.getItem('Id'),
      "selectedText":this.selectedData.text,
      "startIndex":0,
      "annotation":this.selectedAnnotation
  
  }

  this.loader=true;
  
  this.userService.addAnnotation(data).subscribe({
    next:(res:any)=>{
      this.annotationPopuop=false;
      this.selectedAnnotation=null;
      
      this.getUserAnnotations()
      this.loader=true;
    },
    error:(e)=>{
      console.log(e)
      this.loader=false;
    }
  })
}


deleteAnnotation()
{
  var data ={
    "id":this.editableAnnotation.id
  }
  this.loader=true;
  
  this.userService.deleteAnnotation(data).subscribe({
    next:(res:any)=>{

      this.annotationPopuop=false;
      this.selectedAnnotation=null;
      this.editableAnnotation = null;
    
      this.selectedArticle.content = this.tempArticle.content;
      this.getUserAnnotations();
      this.loader=true;
    },
    error:(e)=>{
      console.log(e)
      this.loader=false;
    }
  })

}

updateAnnotation()
{
  var data ={
    
       "id":this.editableAnnotation.id,
        "annotation": this.selectedAnnotation
  
  }

  this.loader=true;
  
  this.userService.updateAnnotation(data).subscribe({
    next:(res:any)=>{

      this.annotationPopuop=false;
      this.selectedAnnotation=null;
      this.editableAnnotation = null;
      this.getUserAnnotations();
      this.loader=true;
    },
    error:(e)=>{
      console.log(e)
      this.loader=false;
    }
  })
}


savehighlight(html: any)
{
  var data ={
    "articleID":this.selectedArticle.articleId,
    "userID": localStorage.getItem('Id'),
    "selectedText":html,
    "startIndex": this.getSelectedOccurrenceIndex().occurrenceIndex,
    "color": this.highlightSelected
  }

  this.userService.addHighlight(data).subscribe({
    next:(res:any)=>{
      this.loader=true;

      this.getUserAnnotations()
    },
    error:(e)=>{
      console.log(e)
      this.loader=false;
    }
  })
}


  getTextHighlights()
  {

    return new Promise((resolve , reject) => {

      var data ={ 
        "userID": localStorage.getItem('Id'),
      }
      this.userService.getTextHighlights(data).subscribe({
        next:(res:any)=>{
    
          if (res.highlights.length>0)
          {
            this.showHighlights(res.highlights)
          }
         
          this.loader=false;
          resolve(true)
        },
        error:(e)=>{
          console.log(e)
          this.loader=false;
        }
      })
    })
  
   
  }

//   wrapTextNodesWithMark(htmlString) {
//     // Create a temporary container to parse the HTML string
//     const tempContainer = document.createElement('div');
//     tempContainer.innerHTML = htmlString;
//     function wrapText(node) {
//         if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "") {
//             const markNode = document.createElement('mark');
//             markNode.textContent = node.nodeValue;
//             node.parentNode.replaceChild(markNode, node);
//         } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes) {
//             for (let i = 0; i < node.childNodes.length; i++) {
//                 wrapText(node.childNodes[i]);
//             }
//         }
//     }
//     wrapText(tempContainer);

//     return tempContainer.innerHTML;
// }

wrapTextNodesWithMark(htmlString, uniqurid , highlightsArray, color) {
  // Create a temporary container to parse the HTML string
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = htmlString;

  const self = this;
  let count = 0;

  // Start the recursive wrapping from the container
  this.wrapText(tempContainer, uniqurid, count, highlightsArray, color);

  // Return the modified HTML string
  return tempContainer.innerHTML;
}

wrapText(node, uniqurid, count, highlightsArray, color) {
  if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "") {
      const markNode = document.createElement('span');
      markNode.textContent = node.nodeValue;


      const id = `${uniqurid}-${count++}`;
    
      markNode.setAttribute('class', color); // Assign unique ID
      markNode.setAttribute('id', id); // Assign unique ID
      

      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.addEventListener("click", () => {
         
            //check if this id exists in highlights 
            highlightsArray.map((item)=>{
              if (id.includes(item.id)){

                 this.removeHighLight(item.id); 
              }
            })
           
          });
        }
      }, 500); 

      node.parentNode.replaceChild(markNode, node);
  } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
          this.wrapText(node.childNodes[i], uniqurid, count, highlightsArray, color);
      }
  }
}

removeHighLight(id)
{

var data ={
  id : id
}

this.userService.deleteHighlight(data).subscribe({
  next:(res:any) => {
   
    this.getUserAnnotations()
    this.libraryLoader=false;
  },
  error:(e) => {
    this.libraryLoader=false;
  }
})
}


  
showHighlights(highlights: any) {


    highlights.map((item: any) => {
      if (item.article_id == this.selectedArticle.articleId)
      {
      // find the index of the substrgin from main strin 
      const index = this.selectedArticle.content.indexOf(item.selected_text)
      const updatedString = this.wrapTextNodesWithMark(item.selected_text , item.id  , highlights, item.color)
      this.selectedArticle.content =this.selectedArticle.content.replace(item.selected_text, updatedString);

      }
       
    })

 
}


  highLightAnnotation(annotations: any) {
    annotations.map((item: any) => {
      if (item.article_id == this.selectedArticle.articleId)
      {
         // Escape special characters in selected_text
      const escapedText = item.selected_text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // const regex = new RegExp(`\\b(${escapedText})\\b`, 'i'); // Match whole words
      const regex = new RegExp(`(${escapedText})`, 'i');



      let matchIndex = 0; // Track the match index for this annotation
      this.selectedArticle.content = this.selectedArticle.content.replace(regex,`<span class="highlight-annotation" id="${item.id}">$1</span>`);
        
      setTimeout(() => {
        const element = document.getElementById(item.id);
        if (element) {
          element.addEventListener("click", (event:Event) => this.showAnnotationPopup((event.target as HTMLElement).id ));
        }
      }, 500); 
      }
     
    });
  }
 

  showAnnotationPopup(id: string)
  {
    this.annotationPopuop = true;
    this.annotation.map((item) => {
      if(item.id == id)
      {
        this.selectedAnnotation = item.annotation;
        this.editableAnnotation = item;
      }
    
    })
    this.editAnnotation= true;
  
  }

 




getUserAnnotations() {

  this.selectedArticle = JSON.parse(JSON.stringify(this.tempArticle))

  var data ={ 
    "userID": localStorage.getItem('Id'),
  }

  this.userService.getAnnotations(data).subscribe({
    next:async (res:any)=>{
    // await  this.getTextHighlights()
    if (res.highlights.length>0)
      {
        this.showHighlights(res.highlights)
      }

      if (res.annotations.length>0) {
        res.annotations.sort((a, b) => a.start_index - b.start_index);
        this.annotation = res.annotations

        this.highLightAnnotation(res.annotations)
        this.annotationPopuop=false;

       
      }
      this.libraryLoader =false;
     
    },
    error:(e) => {
      this.libraryLoader =false;
    }
  })
}


// function to add selected text to the notebook
notebookText: any;
   quizEdit = false;
   addtoNotebook = (event) => {
    this.shownotebookdialog = true;
    var html = "";
    if (typeof window.getSelection != "undefined") {
        var sel = window.getSelection();
        if (sel.rangeCount) {
            var container = document.createElement("div");
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                container.appendChild(sel.getRangeAt(i).cloneContents());
            }
            html = container.innerHTML;
        }
    }
    this.notebookText = html;
    this.quizEdit = true
    this.HideHighlightControls();
   }


   addNewFlashcard = async (event) => {
    var html = "";
    if (typeof window.getSelection != "undefined") {
        var sel = window.getSelection();
        if (sel.rangeCount) {
            var container = document.createElement("div");
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                container.appendChild(sel.getRangeAt(i).cloneContents());
            }
            html = container.innerHTML;
        }
    }
  
    if (html.includes('<tr>') && !html.includes('<table>')) {
      html = '<table><tbody>' + html + '</tbody></table>'
    }
  
    await this.getUserFlashcards()
  
    this.displayFlashcards = true;
    this.createFlashcard = true
    this.openCardDialog(true, html, 'New')
    this.HideHighlightControls()
  }
  
  addExistingFlashcard = async (event) => {
    document.addEventListener('contextmenu', event => event.preventDefault());
    document.onkeydown = function(e) {
      if(e.ctrlKey && e.keyCode == 'A'.charCodeAt(0)){
        return true;
      }
    }
  
    if (typeof window.getSelection != "undefined") {
      var sel = window.getSelection();
      if (sel.rangeCount) {
          var container = document.createElement("div");
          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
              container.appendChild(sel.getRangeAt(i).cloneContents());
          }
          this.html = container.innerHTML;
      }
    }
  
    if (this.html.includes('<tr>') && !this.html.includes('<table>')) {
      this.html = '<table><tbody>' + this.html + '</tbody></table>'
    }

    await this.getUserFlashcards()
    
    this.displayContinue = true
  
    let timer = 0
    let interval = setInterval(() => {
      if (timer == 5) {
        clearInterval(interval)
        this.displayContinue = false
      }
      timer += 1
    }, 1000)
  
    this.displayFlashcards = true;
    this.existingFlashcard = true;
    this.HideHighlightControls();
  }
   


  getUserFlashcards() {
    return new Promise((resolve, reject) => {
      document.addEventListener('contextmenu', event => event.preventDefault());
      document.onkeydown = function(e) {
        if(e.ctrlKey && e.keyCode == 'A'.charCodeAt(0)){
          return true;
        }
      }
      this.flashcards = []
      this.questionFlashcards = []
      this.displayDropdown = false;
      this.createFlashcard = false;
      let data = {
        "userId": localStorage.getItem('Id')
      }
  
      if (this.isDemo) {
        this.decks = [
          {
            'CardReviews': 0,
            'Color': '#62B5FC',
            'DeckID': 1,
            'LastUsed': null,
            'Learning': 0,
            'NewCards': 0,
            'Title': 'Demo Notes',
            'ToReview': 0,
            'TotalTime': 0,
            'UserID': '-1',
            'Flashcards': [
              {
                'FlashcardID': 1,
                'Question': 'Free trial is for testing, saving text is available only for premium users',
                'Answer': '<p>Free trial is for testing, saving text is available only for premium users</p>',
                'DeckID': 1,
                'BuryDate': null,
                'Difficulty': null,
                'IsSuspended': 0,
                'Learning': 0,
                'Mastered': 0,
                'NextStudyDate': null,
                'QuestionID': null,
                'Solved': null,
                'Tags': ['Free Trial', 'Demo'],
                'TimeSpent': null,
                'UpdatedDate': null,
                'usedCard': null
              },
              {
                'FlashcardID': 2,
                'Question': 'Free trial is for testing, saving text is available only for premium users',
                'Answer': '<p>Free trial is for testing, saving text is available only for premium users</p>',
                'DeckID': 1,
                'BuryDate': null,
                'Difficulty': null,
                'IsSuspended': 0,
                'Learning': 0,
                'Mastered': 0,
                'NextStudyDate': null,
                'QuestionID': null,
                'Solved': null,
                'Tags': ['Free Trial', 'Demo'],
                'TimeSpent': null,
                'UpdatedDate': null,
                'usedCard': null
              }
            ]
          }
        ]
        this.decks.forEach(element => {
          element.Flashcards.forEach(flashcard => {
            flashcard.Deck = element.Title
            flashcard.DeckColor = element.Color
            flashcard.Tags = flashcard.Tags
            if (flashcard.QuestionID == this.allQuestions[this.currentQuestionIndex].id) {
              this.questionFlashcards.push(flashcard)
            }
            else {
              this.flashcards.push(flashcard)
            }
            this.tempFlashcards.push(flashcard)
          });
        });
        if (this.decks.length > 0) {
          this.selectedDeck = this.decks[0]
        }
        resolve(true)
      } else {
        this.flashcardService.getUserDeck(data).subscribe((res: any) => {
          this.decks = res.data.decks
          res.data.decks.forEach(element => {
            element.Flashcards.forEach(flashcard => {
              flashcard.Deck = element.Title
              flashcard.DeckColor = element.Color
              flashcard.Tags = JSON.parse(flashcard.Tags)
              this.flashcards.push(flashcard)
              this.tempFlashcards.push(flashcard)
            });
          });
          if (this.decks.length > 0) {
            this.selectedDeck = this.decks[0]
          }
          resolve(true)
        })
      }
    })
  }

  openCardDialog(status: any, html: any, type: any) {
    this.createFlashcard = true
    this.displayDropdown = false;
    this.showFlashcard = false;
    this.card.question = ""
    this.card.answer = ""
    this.card.tags = []
  
    if (this.decks.length <= 0) {
      this.selectedDeck = {
        Title: 'Notes',
        Color: '#62B5FC'
      }
    }
  
    if (type == 'Existing') {
      this.selectedDeck = this.decks[this.decks.findIndex(item => item.DeckID == this.showFlashcards[this.selectedFlashcard].DeckID)]
      this.displayCards = true
      this.card.question = this.showFlashcards[this.selectedFlashcard].Question
      this.card.answer = this.showFlashcards[this.selectedFlashcard].Answer
      this.card.tags = this.showFlashcards[this.selectedFlashcard].Tags
  
      if (this.ckEditorFront) {
        this.ckEditorFront.destroy()
      }
      if (this.ckEditorBack) {
        this.ckEditorBack.destroy()
      }
  
      setTimeout(() => {
        Editor.create(document.querySelector("#ckEditorFront"), {
          toolbar: ['bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList'],
        }).then((editor: any) => {
          this.ckEditorFront = editor
          editor.setData(this.showFlashcards[this.selectedFlashcard].Question)
        })
  
        Editor.create(document.querySelector("#ckEditorBack"), {
          toolbar: ['bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList'],
        }).then((editor: any) => {
          this.ckEditorBack = editor
          editor.setData(this.showFlashcards[this.selectedFlashcard].Answer)
        })
      }, 100)
    }
    if (type == 'New') {
      this.card.questionId = null
  
      if (this.ckEditorFront) {
        this.ckEditorFront.destroy()
      }
      if (this.ckEditorBack) {
        this.ckEditorBack.destroy()
      }
  
      setTimeout(() => {
        Editor.create(document.querySelector("#ckEditorFront"), {
          toolbar: ['bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList'],
        }).then((editor: any) => {
          this.ckEditorFront = editor
          if (status) {
            editor.setData(html)
          }
        })
  
        Editor.create(document.querySelector("#ckEditorBack"), {
          toolbar: ['bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList'],
        }).then((editor: any) => {
          this.ckEditorBack = editor
        })
      }, 100)
    }
  }

  changeView() {
    if (this.flashcardView == 'Single Side View') {
      this.flashcardView = 'Double Side View'
    }
    else {
      this.flashcardView = 'Single Side View'
    }
  }
  
  prevCardIndex() {
    if (this.selectedFlashcard > 0) {
      this.selectedFlashcard --
      this.position = 'Front'
    }
  }
  
  nextCardIndex() {
    if (this.selectedFlashcard < this.showFlashcards.length - 1) {
      this.selectedFlashcard ++
      this.position = 'Front'
    }
  }

  closeFlashcards() {
    document.addEventListener('contextmenu', event => event.preventDefault());
    document.onkeydown = function(e) {
      if(e.ctrlKey && e.keyCode == 'A'.charCodeAt(0)){
        return false;
      }
    }
    this.displayCards = false
    this.displayContinue = false
    this.showFlashcard = false
    this.displayDropdown = false
    this.createFlashcard = false
    this.existingFlashcard = false
  }

  addNewUserDeck() {
    if (this.isDemo) {
      this.displayDeck = false
      this.decks.push({
        'CardReviews': 0,
        'Color': this.deck.color,
        'DeckID': this.decks.length + 1,
        'LastUsed': null,
        'Learning': 0,
        'NewCards': 0,
        'Title': this.deck.title,
        'ToReview': 0,
        'TotalTime': 0,
        'UserID': '-1',
        'Flashcards': []
      })
    } else {
      this.flashcardService.addUserDeck(this.deck).subscribe((res: any) => {
        if (!res.error) {
          this.decks.push({
            Title: this.deck.title,
            Color: this.deck.color,
            DeckID: res.data.deckId,
            UserID: localStorage.getItem('Id'),
            Flashcards: []
          })
          this.deck.title = ""
          this.displayDeck = false
        }
      })
    }
  }


  imgToNotebook() {
    this.shownotebookdialog = true;
  
    let html = '';
    if (this.showType === 0) {
      html = '<p></p><img src="' + this.showImage + '">'    
    } else if (this.showType === 1 && this.showImage.includes('<table>')) {
      html = this.showImage
    } else if (this.showType === 2) {
      html = '<p></p><video controls> <source src="' + this.showImage + '"type="video/mp4"> </video>'    
    } else if (this.showType === 3) {
      html = '<p></p><audio controls> <source src="' + this.showImage + '"type="audio/mp3"> </audio>'    
    }
  
    this.notebookText = html;
    this.quizEdit = true
    // this.removeImageDiv()
  }

  async imgToExistingFlashcard() {
    let html = '';
    if (this.showType === 0) {
      html = '<p></p><img src="' + this.showImage + '">'    
    } else if (this.showType === 1 && this.showImage.includes('<table>')) {
      html = this.showImage
    } else if (this.showType === 2) {
      html = '<p></p><video controls> <source src="' + this.showImage + '"type="video/mp4"> </video>'    
    } else if (this.showType === 3) {
      html = '<p></p><audio controls> <source src="' + this.showImage + '"type="audio/mp3"> </audio>'    
    }
    await this.getUserFlashcards()
  
    this.displayImg = false
    this.displayContinue = true
  
    let timer = 0
    let interval = setInterval(() => {
      if (timer == 5) {
        clearInterval(interval)
        this.displayContinue = false
      }
      timer += 1
    }, 1000)
  
    this.displayFlashcards = true;
    this.existingFlashcard = true
  }

  async imgToNewFlashcard() {
    let html = '';
    if (this.showType === 0) {
      html = '<p></p><img src="' + this.showImage + '">'    
    } else if (this.showType === 1 && this.showImage.includes('<table>')) {
      html = this.showImage
    } else if (this.showType === 2) {
      html = '<p></p><video controls> <source src="' + this.showImage + '"type="video/mp4"> </video>'    
    } else if (this.showType === 3) {
      html = '<p></p><audio controls> <source src="' + this.showImage + '"type="audio/mp3"> </audio>'    
    }
    await this.getUserFlashcards()
  
    this.displayImg = false
    this.displayFlashcards = true;
    this.createFlashcard = true
    this.openCardDialog(true, html, 'New')
  }
  

updateHTML(side: any) {
  if (side == 'Front') {
    let existingData = this.ckEditorFront.getData() + '<p>' + this.html + '</p>'
    this.ckEditorFront.setData(existingData)
  }
  if (side == 'Back') {
    let existingData = this.ckEditorBack.getData() + '<p>' + this.html + '</p>'
    this.ckEditorBack.setData(existingData)
  }
  this.displayCards = false
}

editUserFlashcard() {
  let data = {
    'deckId': this.showFlashcards[this.selectedFlashcard].DeckID,
    'question': this.ckEditorFront.getData(),
    'answer': this.ckEditorBack.getData(),
    'tags': this.card.tags,
    'flashcardId': this.showFlashcards[this.selectedFlashcard].FlashcardID
  }
  if (this.isDemo) {
    this.existingFlashcard = false
    this.createFlashcard = false
    this.displayEditFlashcard = false
    let index = this.decks.findIndex((item: any) => item.DeckID === data.deckId)
    let flashcardIndex = this.decks[index].Flashcards.findIndex((item: any) => item.FlashcardID === data.flashcardId)
    this.decks[index].Flashcards[flashcardIndex].Question = data.question
    this.decks[index].Flashcards[flashcardIndex].Answer = data.answer
    this.decks[index].Flashcards[flashcardIndex].Tags = data.tags
  } else {
    this.flashcardService.editDeckFlashcard(data).subscribe((res: any) => {
      this.existingFlashcard = false
      this.createFlashcard = false
      this.displayEditFlashcard = false
      this.getUserFlashcards()
    })
  }
}

addDeckFlashcard() {
  this.card.question = this.ckEditorFront.getData()
  this.card.answer = this.ckEditorBack.getData()
  if (this.card.deckId == -1) {
    this.card.deckId = this.selectedDeck.DeckID
  }

  if (this.isDemo) {
    let index = this.decks.findIndex((item: any) => item.DeckID === this.card.deckId)
    let flashcard = {
      'FlashcardID': this.decks[index].Flashcards.length + 1,
      'Question': this.card.question,
      'Answer': this.card.answer,
      'DeckID': this.card.deckId,
      'BuryDate': null,
      'Difficulty': null,
      'IsSuspended': 0,
      'Learning': 0,
      'Mastered': 0,
      'NextStudyDate': null,
      'QuestionID': this.card.questionId,
      'Solved': null,
      'Tags': this.card.tags,
      'TimeSpent': null,
      'UpdatedDate': null,
      'usedCard': null
    }
    this.decks[index].Flashcards.push(flashcard)
    this.decks.forEach(element => {
      element.Flashcards.forEach(flashcard => {
        flashcard.Deck = element.Title
        flashcard.DeckColor = element.Color
        flashcard.Tags = flashcard.Tags
        if (flashcard.QuestionID == this.allQuestions[this.currentQuestionIndex].id) {
          this.questionFlashcards.push(flashcard)
        }
        else {
          this.flashcards.push(flashcard)
        }
        this.tempFlashcards.push(flashcard)
      });
    });
    this.createFlashcard = false
    this.displayFlashcards = true;
  } else {
    if (this.decks.length <= 0) {
      this.decks.push({
        Title: 'Notes',
        Color: '#62B5FC'
      })
      this.addUserDeck()
    } else {
      this.flashcardService.addDeckFlashcard(this.card).subscribe((res: any) => {
        this.card.question = ""
        this.card.answer = ""
        this.card.tags = []
        this.card.deckId = -1
        this.createFlashcard = false
        this.displayFlashcards = true;
        this.getUserFlashcards()
      })
    }
  }
}

addUserDeck() {
  let deck = {
    'title': 'Notes',
    'color': '#62B5FC',
    'userId': localStorage.getItem('Id')
  }
  if (this.isDemo) {
    this.displayDeck = false
    this.decks.push({
      'CardReviews': 0,
      'Color': this.deck.color,
      'DeckID': this.decks.length + 1,
      'LastUsed': null,
      'Learning': 0,
      'NewCards': 0,
      'Title': this.deck.title,
      'ToReview': 0,
      'TotalTime': 0,
      'UserID': '-1',
      'Flashcards': []
    })
  } else {
    this.flashcardService.addUserDeck(deck).subscribe((res: any) => {
      if (res.data) {
        this.card.deckId = res.data.deckId
        this.addDeckFlashcard()
      }
    })
  }
}

selectFlashcard(index: any, array: any) {
  this.showFlashcards = array
  this.selectedFlashcard = index
  this.searcher = false
  this.flashcardKeyword = ''

  if (this.existingFlashcard) {
    this.displayContinue = false
    this.openCardDialog(true, this.html, 'Existing')
  }
  else {
    this.showFlashcard = true
    this.position = 'Front'
    this.flashcardView = 'Single Side View'
  }
}

editDeckFlashcard() {
  let data = {
    'deckId': this.showFlashcards[this.selectedFlashcard].DeckID,
    'question': this.ckEditorFront.getData(),
    'answer': this.ckEditorBack.getData(),
    'tags': this.card.tags,
    'flashcardId': this.showFlashcards[this.selectedFlashcard].FlashcardID
  }
  if (this.isDemo) {
    this.existingFlashcard = false
    this.createFlashcard = false
    let index = this.decks.findIndex((item: any) => item.DeckID === data.deckId)
    let flashcardIndex = this.decks[index].Flashcards.findIndex((item: any) => item.FlashcardID === data.flashcardId)
    this.decks[index].Flashcards[flashcardIndex].Question = data.question
    this.decks[index].Flashcards[flashcardIndex].Answer = data.answer
    this.decks[index].Flashcards[flashcardIndex].Tags = data.tags
  } else {
    this.flashcardService.editDeckFlashcard(data).subscribe((res: any) => {
      this.existingFlashcard = false
      this.createFlashcard = false
      this.getUserFlashcards()
    })
  }
}

updateFlags(flag: any) {
  this.flags.bookmarks = false;
  this.flags.showContent = false;
  this.flags.showSearch = false;
  this.flags[flag] = true;
  
  // Close mobile sidebar when navigating on mobile
  if (this.isMobile) {
    this.showMobileSidebar = false;
  }
}

selectDefault() {
  this.updateFlags('showContent');
  if (this.isDemo) {
    this.demoOptions.status = !this.demoOptions.status;
    this.selectedArticle = JSON.parse(JSON.stringify(this.demoOptions));
    this.tempArticle = JSON.parse(JSON.stringify(this.selectedArticle));
  } else {
    this.tourOptions.status = !this.tourOptions.status;
    this.selectedArticle = JSON.parse(JSON.stringify(this.tourOptions));
    this.tempArticle = JSON.parse(JSON.stringify(this.selectedArticle));
    for (let i = 0; i < this.libraryObject.length; i++) {
      this.libraryObject[i].status = false;
      this.libraryObject[i]?.subTopics.forEach(element => {
        element.status = false;
      });
    }
    this.HideHighlightControls();
  }
}

navigatePageBack() {
  this.prevPages.splice(this.prevPages.length - 1, 1);
  const article = this.prevPages[this.prevPages.length - 1];
  const parentArticle = this.libraryObject.find((element) => article.parentId.includes(element.articleId))
  const childArticle = parentArticle.subTopics.find((element) => element.articleId === article.articleId);

  this.activeMainCategory(parentArticle)
  this.activeSubcategory(childArticle, parentArticle.subTopics, parentArticle.title, true);
}

resetSearch() {
  this.searchWord = null;
  this.filteredArticles = [];
}

  increaseFontSize(): void {
    if(this.currentFontSize <= 30) {
      this.currentFontSize ++;
    }
    document.getElementById('articleContent').style.fontSize = `${this.currentFontSize}px`
    sessionStorage.setItem('libraryFontSize', JSON.stringify(this.currentFontSize))
  }

  decreaseFontSize(): void {
    if(this.currentFontSize >= 10) {
      this.currentFontSize --;
    }
    document.getElementById('articleContent').style.fontSize = `${this.currentFontSize}px`
    sessionStorage.setItem('libraryFontSize', JSON.stringify(this.currentFontSize))
  }

  resetFontSize(): void {
    this.currentFontSize = 16;
    document.getElementById('articleContent').style.fontSize = `${this.currentFontSize}px`
    sessionStorage.setItem('libraryFontSize', JSON.stringify(this.currentFontSize))
  }

  changeHighlightMode() {
    this.highlightOnlyMode = !this.highlightOnlyMode;
    sessionStorage.setItem('libraryHighlightOnly',JSON.stringify(this.highlightOnlyMode));
  }

  changeMultiHighlight() {
    this.multiHighlightMode = !this.multiHighlightMode;
    sessionStorage.setItem('libraryMultiHighlight',JSON.stringify(this.multiHighlightMode));
  }

  navigateToSearchedArticle(article: any) {
    const parentArticle = this.libraryObject.find((element) => article.parentId.includes(element.articleId))
    const childArticle = parentArticle.subTopics.find((element) => element.articleId === article.articleId);
    this.activeMainCategory(parentArticle);
    this.activeSubcategory(childArticle, parentArticle.subTopics, parentArticle.title, false);
  }

  addIDsToFigure(content: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const links = doc.querySelectorAll('a');

    links.forEach((link) => {
      if (link.href !== 'javascript:void(0)') {
        link.id = link.href;
        link.setAttribute('data-id', link.href);
        link.href = JSON.parse(JSON.stringify('javascript:void(0)'));
      }
    });

    return doc.body.innerHTML;
  }

  replaceTableWithLink(content: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');

    const tables = doc.querySelectorAll('figure');
    if (tables.length > 0) {
      tables.forEach((table) => {
        const tableHtml = table.innerHTML;
        const anchor = document.createElement('a');
        anchor.id = 'showTable';
        anchor.innerText = 'Table';
        anchor.href = 'javascript:void(0)';
        anchor.setAttribute('data-id', tableHtml);
  
        table.replaceWith(anchor);
      })
    }

    return doc.body.innerHTML;
  }

  // --- AI Flashcards Implementation --- //

  generateAIFlashcards = (event) => {
    document.getElementById('control-library').style.display = 'none';
    var html = "";
    if (typeof window.getSelection != "undefined") {
        var sel = window.getSelection();
        if (sel.rangeCount) {
            var container = document.createElement("div");
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                container.appendChild(sel.getRangeAt(i).cloneContents());
            }
            html = container.innerHTML;
        }
    }
  
    if (html.includes('<tr>') && !html.includes('<table>')) {
      html = '<table><tbody>' + html + '</tbody></table>'
    }
    this.generateFlashcardsUsingAI(html);
  }
  
  generateFlashcardsUsingAI(html: any) {
    let question = 'Generate flashcards related to the following text: \n ';
    question += html;
    const data = {
      "question": question,
      "system": `Returns the flashcards in array json form. e.g. { deck: 'deck1', flashcards: [{ question': 'question', 'answer': 'answer', 'tags': ['tag 1', 'tag 2'] }]}. Please follow the instructions: \n 
      1. Text should have atleast 7-8 proper words and should be meaningful to generate flashcards otherwise return empty array of flashcards.
      2. Generated flashcards count should depend on the provided text length. Minimum flashcards can be 1-3.
      3. If length of provided text is less than 1000 words then generate maximum 2 flashcards.
      4. If length of provided text is greater than 1000 words then generate maximum 5 flashcards.
      5. Generated per flashcard tags count should not exceed more than 5 tags.
      6. Deck name should be returned as 1-2 words related to the questions.
      7. Don't include any irrevelant text like (\`\`\`json).`
    }
    this.aiLoader = true;
    this.aiText = 'AI Flashcards';
    this.aiFlashcards = null;
    this.quizService.generateUsingOpenAI(data).subscribe(async (res: any) => {
      try {
        const flashcardResponse = JSON.parse(res.response);
        if (flashcardResponse.flashcards.length > 0) {
          this.aiFlashcards = flashcardResponse;
          this.getAIDecks();
          this.displayAIFlashcards = true;
        } else {
          this.messageService.add({severity:'error', summary:'AI Generation Failed', detail:'Something went wrong while generating AI statistics!'});
        }
        this.aiLoader = false;
      } catch (e) {
        this.aiLoader = false;
        this.messageService.add({severity:'error', summary:'AI Generation Failed', detail:'Something went wrong while generating AI statistics!'});
      }
    }, (error: any) => {
      this.aiLoader = false;
      this.messageService.add({severity:'error', summary:'AI Generation Failed', detail:'Something went wrong while generating AI statistics!'});
    })
  }
  
  updateQuestionFlashcards() {
    this.displayAIFlashcards = false;
    return new Promise((resolve: any) => {
      const data = {
        deckId: this.flashcardSelection === 0 ? this.selectedAIDeck : null,
        title: this.flashcardSelection === 1 ? this.selectedAIDeck : null,
        color: '#62B5FC',
        flashcards: this.aiFlashcards.flashcards,
        questionId: null,
        userId: localStorage.getItem('Id')
      }
      this.quizService.updateQuestionFlashcards(data).subscribe((res: any) => {
        this.displayFlashcards = true;
        this.messageService.add({severity:'success', summary:'AI Flashcards Generated', detail:'Your flashcards are generated successfully.'});
        this.getUserFlashcards()
        resolve(res);
      })
    })
  }
  
  getAIDecks() {
    let data = {
      "userId": localStorage.getItem('Id')
    }
  
    this.flashcardService.getUserDeck(data).subscribe((res: any) => {
      this.aiDecks = res.data.decks
      if (this.aiDecks.length > 0) {
        this.selectedAIDeck = this.aiDecks[0].DeckID;
      }
    })
  }
  
  changeDeckOption() {
    this.selectedAIDeck = null;
    if (this.flashcardSelection === 0) {
      if (this.aiDecks.length > 0) {
        this.selectedAIDeck = this.aiDecks[0].DeckID;
      }
    }
  }

  openFeedbackDialog() {
    this.feedbackText = '';
    this.displayFeedback = true;
  }

  addArticleFeedback() {
    const data = {
      articleId: this.selectedArticle.articleId,
      userId: localStorage.getItem('Id'),
      feedback: this.feedbackText
    }
    this.buttonLoader = true;
    this.userService.addArticleFeedback(data).subscribe({
      next:(res:any) => {
        this.displayFeedback = false;
        this.buttonLoader = false;
        this.messageService.add({severity:'success', summary:'Feedback Submitted', detail:'Thanks for submitting the feedback.'});
      },
      error:(e)=>{
        this.buttonLoader = false;
        this.messageService.add({severity:'error', summary:'Something went wrong', detail:'Error while submitting feedback.'});
      }
    })
  }

  searchArticleContent(term: any) {
    return new Promise((resolve: any) => {
      const data = {
        term: term
      }
      this.libraryLoader = true;
      this.userService.searchArticleContent(data).subscribe({
        next: (res: any) => {
          this.libraryLoader = false;
          const searchedArticles = res.filteredArticles;
          for (let i = 0; i < searchedArticles.length; i++) {
            this.libraryObject.forEach((element: any) => {
              if (element.subTopics?.length > 0) {
                element.subTopics.forEach((topic: any) => {
                  if (topic.title === searchedArticles[i].title && !this.filteredArticles.find((article: any) => article.title === searchedArticles[i].title)) {
                    searchedArticles[i] = {...searchedArticles[i], ...topic}
                    this.filteredArticles.push(searchedArticles[i])
                  }
                })
              }
            })
          }
          resolve(true);
        },
        error: (e) => {
          resolve(false);
        }
      })
    })
  }

  getArticleContent(articleId: any) {
    return new Promise((resolve: any) => {
      const data = {
        articleId: articleId
      }
      this.userService.getArticleContent(data).subscribe({
        next: (res: any) => {
          resolve(res.articleContent.content)
        },
        error: (e) => {
          resolve('');
        }
      })
    })
  }

  viewUserArticle(articleId: any) {
    const data = {
      userId: localStorage.getItem('Id'),
      articleId: articleId
    }
    this.userService.viewUserArticle(data).subscribe({
      next: () => {},
      error: (e) => {
        console.error(e)
      }
    })
  }

  // Mobile responsiveness methods
  checkMobileDevice(): void {
    this.isMobile = window.innerWidth <= 768;
    if (!this.isMobile) {
      this.showMobileSidebar = false;
    }
  }

  toggleMobileMenu(): void {
    this.showMobileSidebar = !this.showMobileSidebar;
  }
}
